(function() {
	angular
		.module('main')
		.controller('CalendarSettingsController', CalendarSettingsController);

	CalendarSettingsController.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'$http',
		'$timeout',
		'$routeParams',
		'messageService',
		'settingsService',
		'calendarIntegrationService'
	];

	function CalendarSettingsController(
		$scope,
		$rootScope,
		$location,
		$http,
		$timeout,
		$routeParams,
		messageService,
		settingsService,
		calendarIntegrationService
	) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.isCalendarSettingsSaveSpinnningWheelActive = false;
			$scope.isGoogleIntegrationSpinnningWheelActive = false;
			$scope.isGoogleSynchronizationSpinnningWheelActive = false;

			initCalendarSettings();

			const code = $routeParams.code;

			if (code) {
				if ($rootScope.activateCode !== code) {
					$rootScope.activateCode = code;
					$rootScope.lockIntegration = true;
					$scope.isGoogleSynchronizationSpinnningWheelActive = true;
					messageService.showToaster('i_0', 'googleCalendar');
					$scope.save(code);
				}
			} else {
				$rootScope.activateCode = '';
				getActivatedCalendar();
				spiningOnStart();
			}
		});

		$scope.calendarIntegrationStart = () => {
			$scope.isGoogleSynchronizationSpinnningWheelActive = true;
			calendarIntegrationService.connectGoogleCalendar().subscribe(
				results => {
					window.location.assign(results.message);
				},
				() => {
					handleErrorCalendarIntegration();
				}
			);
		};

		function spiningOnStart() {
			if ($rootScope.lockIntegration === true) {
				$scope.isGoogleSynchronizationSpinnningWheelActive = true;
			}
		}

		function initCalendarSettings() {
			settingsService.timeFormatSettings.subscribe(data => {
				$scope.calendarSettings = JSON.parse(JSON.stringify(data));
			});
		}

		$scope.saveCalendarSettings = () => {
			$scope.isCalendarSettingsSaveSpinnningWheelActive = true;
			settingsService
				.updateTimeFormatSettings($scope.calendarSettings)
				.subscribe(
					() => {
						settingsService.applySavedSettings();
						messageService.showToaster('s_0', 'calendar');
					},
					error => {
						messageService.showToaster('e_0', 'general', error.error);
					},
					() => {
						$scope.isCalendarSettingsSaveSpinnningWheelActive = false;
					}
				);
		};

		function getActivatedCalendar() {
			calendarIntegrationService.getActivatedCalendar().subscribe(
				result => {
					$scope.activatedCalendar = result.data.state === 'INTEGRATED';
					if (result.data.state === 'SYNCHRONIZATION') {
						$rootScope.lockIntegration = true;
						$scope.isGoogleSynchronizationSpinnningWheelActive = true;
					}
				},
				() => {
					handleErrorCalendarIntegration();
				}
			);
		}

		$scope.showSynchronize = function() {
			$('#synchronizeModal').modal('show');
		};

		$scope.synchronize = function() {
			$scope.isGoogleIntegrationSpinnningWheelActive = true;
			$rootScope.lockIntegration = true;
			$scope.synchronizing = true;
			calendarIntegrationService.synchronizeGoogleCalendar().subscribe(
				() => {
					checkResultCalendarSynchronize();
				},
				() => {
					handleErrorCalendarIntegration();
				}
			);
		};

		$scope.disconnectGoogle = () => {
			$scope.isGoogleIntegrationSpinnningWheelActive = false;
			$scope.isGoogleSynchronizationSpinnningWheelActive = true;
			$scope.activatedCalendar = false;
			calendarIntegrationService.disconnectGoogleCalendar().subscribe(
				() => {
					messageService.showToaster('s_2', 'googleCalendar');
					$scope.isGoogleSynchronizationSpinnningWheelActive = false;
				},
				() => {
					handleErrorCalendarIntegration();
				},
				() => {
					calendarIntegrationService.stopCalendarInterval();
					handleErrorCalendarIntegration();
				}
			);
		};

		$scope.save = code => {
			$scope.isGoogleSynchronizationSpinnningWheelActive = true;
			calendarIntegrationService.updateGoogleCalendarStatus(code).subscribe(
				() => {
					checkResultCalendarIntegration();
				},
				() => {
					handleErrorCalendarIntegration();
				}
			);
		};

		function checkResultCalendarIntegration() {
			$rootScope.lockIntegration = true;
			calendarIntegrationService.startCalendarinterval();
			calendarIntegrationService.calendarInterval().subscribe(
				result => {
					if (result.data.state === 'INTEGRATED') {
						calendarIntegrationService.stopCalendarInterval();
					}
				},
				() => {
					handleErrorCalendarIntegration();
				},
				() => {
					$scope.isGoogleSynchronizationSpinnningWheelActive = false;
					$rootScope.lockIntegration = false;
					$scope.activatedCalendar = true;
					messageService.showToaster('s_1', 'googleCalendar');
					$location.url($location.path());
				}
			);
		}

		function checkResultCalendarSynchronize() {
			calendarIntegrationService.startCalendarinterval();
			calendarIntegrationService.calendarInterval().subscribe(
				result => {
					if (result.data.state === 'INTEGRATED') {
						calendarIntegrationService.stopCalendarInterval();
					}
				},
				() => {
					handleErrorCalendarIntegration();
				},
				() => {
					$scope.synchronizing = false;
					$scope.isGoogleIntegrationSpinnningWheelActive = false;
					$rootScope.lockIntegration = false;
					messageService.showToaster('s_1', 'googleCalendar');
					$('#synchronizeModal').modal('hide');
					$location.url($location.path());
				}
			);
		}

		function handleErrorCalendarIntegration() {
			$scope.activatedCalendar = false;
			$scope.isGoogleIntegrationSpinnningWheelActive = false;
			$scope.isGoogleSynchronizationSpinnningWheelActive = false;
			$rootScope.lockIntegration = false;
			$location.url($location.path());
		}
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/calendarSettingsController.js